import { Injectable, inject } from '@angular/core'
import { Job } from './job'
import { environment } from '../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import { RestClientPaged } from '@elderbyte/ngx-starter'

@Injectable({
  providedIn: 'root',
})
export class JobService extends RestClientPaged<Job, string> {
  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const http = inject(HttpClient)
    super(environment.apiPath + '/jobs', http, {})
  }
}
